import { useCallback, type Dispatch, type SetStateAction } from 'react';
import {
  BUILDER_DEVICE_TAB,
  BUILDER_PASS_TAB,
  type BuilderDeviceTab,
  type BuilderPassTab,
} from '../utils/templateBuilderTabs';

const LOCATIONS_SECTION_ID = 'locations-section';
const SCROLL_AFTER_TAB_MS = 200;
const SCROLL_TOP_BEFORE_SECTION_MS = 120;
const SCROLL_TOP_OFFSET_PX = 25;
const SCROLL_TO_SECTION_DURATION_MS = 1200;

function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function animateScrollToY(targetY: number, durationMs: number) {
  const startY = window.scrollY;
  const delta = targetY - startY;
  if (Math.abs(delta) < 1) return;

  const startTime = performance.now();

  const step = (now: number) => {
    const elapsed = now - startTime;
    const t = Math.min(1, elapsed / durationMs);
    window.scrollTo(0, startY + delta * easeInOutCubic(t));
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

function scrollPageTopThenLocationsSection() {
  window.setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    window.setTimeout(() => {
      const section = document.getElementById(LOCATIONS_SECTION_ID);
      if (section) {
        const position = section.getBoundingClientRect().top + window.scrollY;
        animateScrollToY(
          position - SCROLL_TOP_OFFSET_PX,
          SCROLL_TO_SECTION_DURATION_MS
        );
      }
    }, SCROLL_TOP_BEFORE_SECTION_MS);
  }, SCROLL_AFTER_TAB_MS);
}

export function useLocationBuilderNavigation(
  setSelectedTab: Dispatch<SetStateAction<BuilderDeviceTab>>,
  setSelectedPassTab: Dispatch<SetStateAction<BuilderPassTab>>
) {
  const navigateToSharedGeofencing = useCallback(() => {
    setSelectedTab(BUILDER_DEVICE_TAB.SHARED);
    setSelectedPassTab(BUILDER_PASS_TAB.FEATURES);
    scrollPageTopThenLocationsSection();
  }, [setSelectedTab, setSelectedPassTab]);

  const navigateToAppleLocationNotifications = useCallback(
    (_locationId: string) => {
      setSelectedTab(BUILDER_DEVICE_TAB.APPLE);
      setSelectedPassTab(BUILDER_PASS_TAB.FEATURES);
      scrollPageTopThenLocationsSection();
    },
    [setSelectedTab, setSelectedPassTab]
  );

  return {
    navigateToSharedGeofencing,
    navigateToAppleLocationNotifications,
  };
}
